/**
 * Catches deploy skew between the Cosmos frontend-tool registry and the
 * add-in build.  If the backend registered a tool whose handler key the
 * client doesn't know, the LLM will eventually call that tool and the
 * `tool_call` SSE event will arrive with no local function to run.
 *
 * Call once on Office ready.  Returns the fetched manifest so callers can
 * cache it for diagnostics; mismatches are logged to the console so QA
 * spots them before users do.
 */

import { handlers } from "./handlers";

export interface FrontendToolManifestEntry {
  tool_name: string;
  handler: string;
  timeout_ms: number;
  input_schema: Record<string, unknown>;
  version: string;
}

export async function verifyManifest(
  apiBaseUrl: string,
  host = "outlook",
): Promise<FrontendToolManifestEntry[]> {
  const res = await fetch(
    `${apiBaseUrl}/api/v1/tool-registry/tools/frontend/manifest?host=${encodeURIComponent(host)}`,
  );
  if (!res.ok) {
    console.warn(
      `[verifyManifest] manifest fetch failed (${res.status}) — skipping handler-coverage check`,
    );
    return [];
  }

  const manifest = (await res.json()) as FrontendToolManifestEntry[];
  const missing = manifest.filter((entry) => !(entry.handler in handlers));
  if (missing.length > 0) {
    console.error(
      "[verifyManifest] add-in is missing handlers for registered frontend tools:",
      missing.map((m) => `${m.tool_name} -> ${m.handler}`),
    );
  }
  return manifest;
}
